module.exports = __webpack_public_path__ + "static/campaign-share-838f715287c461b2308625fa30b71b11.png";